import React from "react";
import { CheckIcon } from "../../../icons";

export type ListItem<T extends string> = {
  key: T;
  text: string | React.ReactNode;
  unavailable?: boolean;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};

export type DropdownItemProps<T extends string> = {
  item: ListItem<T>;
  isSelected: boolean;
};
const DropdownItem = ({ item, isSelected }: DropdownItemProps<string>) => {
  const Logo = item.icon;
  return (
    <div className="flex items-center">
      {Logo && <Logo className="flex-shrink-0 h-6 w-6 rounded-full mr-3" />}
      <span className={"mr-6 block truncate font-normal"}>{item.text}</span>
      {isSelected && (
        <span className="ml-auto">
          <CheckIcon className="h-5 w-5" />
        </span>
      )}
    </div>
  );
};

export default DropdownItem;
